import { useState, useEffect } from 'react';
import { auth } from '../apiClient';

export interface Profile {
  id: string;
  email: string;
  role: 'super_admin' | 'provider' | 'customer';
  fullName: string;
}

export const useAuth = () => {
  const [profile, setProfile] = useState<Profile | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const user = auth.getUser();
    if (user) {
      setProfile({
        id: user.id,
        email: user.email,
        role: user.role,
        fullName: user.fullName,
      });
    }
    setLoading(false);
  }, []);

  return { profile, loading, isAuthenticated: auth.isAuthenticated() };
};
